import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store/store";


import {

  setCashIncomeForm,
  updateCashIncomeField,
  clearCashIncomeForm,

  setLoading,

  openModal,
  closeModal

} from "../../store/slices/cash/cashIncomeSlice";

import useAlerts from "../useAlerts";
import useLoading from "../useLoading";
import useApiErrorHandler from "../useApiErrorHandler";

import { useCashSession } from "./useCashSession";
import { useCashMovements } from "./useCashMovements";
import { CashMovementType } from "../../types/cash/CashMovementType";
import CashIncomeService from "../../services/cash/CashIncomeService";

export const useCashIncome = () => {

  const dispatch: AppDispatch = useDispatch();

  const { form, loading, showModal } = useSelector(
    (state: RootState) => state.cashIncome
  );

  const { show: showAlert } = useAlerts();

  const { handle } = useApiErrorHandler();

  const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  const { getActiveSession } = useCashSession();
  const { getSessionMovements } = useCashMovements();

  /**
   * 💰 Registrar ingreso
   */
  const income = async (data: any) => {

    try {

      showLoadingIndicator();
      dispatch(setLoading(true));

      const response = await CashIncomeService.income(data);

      if (response?.statusCode === 200 || response?.statusCode === 201) {

        showAlert(
          response.type,
          response.title,
          response.message
        );

        dispatch(closeModal());
        dispatch(clearCashIncomeForm());

        await getActiveSession();

        await getSessionMovements(
          data.sessionId,
          [CashMovementType.INCOME]
        );

      }

    } catch (error) {

      handle(error);

    } finally {

      hideLoadingIndicator();
      dispatch(setLoading(false));

    }

  };

  const updateField = (field: string, value: any) => {

    dispatch(updateCashIncomeField({
      field,
      value
    }));

  };

  const setForm = (data: any) => {

    dispatch(setCashIncomeForm(data));

  };

  const clearForm = () => {

    dispatch(clearCashIncomeForm());

  };

  const open = () => dispatch(openModal());

  const close = () => dispatch(closeModal());

  const clear = () => {
    dispatch(clearCashIncomeForm());
    dispatch(closeModal());
  };

  return {

    form,
    loading,
    showModal,

    income,

    updateField,
    setForm,
    clearForm,
    clear,

    open,
    close

  };

};